export const gray25 = '#404040';
export const gray40 = '#616161';
export const gray45 = '#757575';
export const gray60 = '#9e9e9e';
export const gray75 = '#bdbdbd';
export const failure = '#e22134';
export const success = '#1db954';
export const warning = '#ff5722';
